import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Api_Config from '../../code/api/ApiConfig';
import BidPackInfo from "../../code/models/BidPackInfo";
import FileUploaderModalForm from "../FileUploaderModalForm";
import { ImportDocumentType } from "../../code/enums/Enums";
import BidPeriodFileGroupInfo from "../../code/models/BidPeriodFileGroupInfo";
import ApiDocument from "../../code/api/ApiDocument";
import Auth from "../../code/auth/Auth";

interface IAdminBidPackLoadBidPacks {
    bidPackInfo: BidPackInfo;
    onRefreshRequest: Function;
}

export default function AdminBidPackLoadBidPacks({ bidPackInfo, onRefreshRequest }: IAdminBidPackLoadBidPacks) {
    const bpFileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "fileName",
            title: "File Name",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "created",
            title: "Added",
            visible: true,
            formatData: formatDate,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "bidPeriodFileId",
            title: "",
            visible: true,
            formatData: buildViewDocumentColumn,
            type: CclDataTableColumnType.Data
        }
    ];

    function formatDate(val: Date) {
        let sval = ("" + val).replace("T", " ");
        val = new Date(sval);
        let dateStr = val.toISOString().split('T')[0];
        let time = new Intl.DateTimeFormat('en-us', { hour: '2-digit', minute: '2-digit', hour12: true }).format(val);
        return `${dateStr} ${time}`;
    }

    var comp = Api_Config.getSelectedCompany();

    function buildViewDocumentColumn(val: any, rowData: any) {
        let buttonClasses = "btn btn-primary btn-sm";
        let token = Auth.getAuthToken();
        return (
            <a className={buttonClasses} href={`${comp.adminApiUrl}/document/doc/${rowData.bidPeriodFileId}?t=${token}`} target="_blank" >View</a>
        )
    }

    function currentFileGroup(): BidPeriodFileGroupInfo {
        return bidPackInfo.fileGroup || new BidPeriodFileGroupInfo();
    }

    function handleBidPackDeleteClick() {
        var res = window.confirm("Delete Current Bid Pack Group?");
        if (res) {
            ApiDocument.deleteFileGroup(currentFileGroup().bidPeriodFileGroupId).then(success => {
                if (success) {
                    onRefreshRequest();
                }
            });
        }
    }

    function handleBidPackCreateClick() {
        ApiDocument.createFileGroup(ImportDocumentType.bid_pack).then(success => {
            if (success) {
                onRefreshRequest();
            }
        });
    }

    function anyOpenFileGroup(): boolean {
        return !!bidPackInfo.fileGroup &&
            bidPackInfo.fileGroup.groupStatus.toLowerCase() === "ready";
    }

    function onUploadReportUploadSuccess() {
        onRefreshRequest();
    }

    return (
        <React.Fragment>
            <div className="bidpackimport-loadbidpacks">
                {!anyOpenFileGroup() &&
                    <div className="bidpackimport-btngroup">
                        <button className="btn btn-primary btn-sm" onClick={handleBidPackCreateClick}>Create Bid Pack Group</button>
                    </div>
                }
                {!!anyOpenFileGroup() &&
                    <div className="bidpackimport-btngroup">
                        <button className="btn btn-primary btn-sm" onClick={handleBidPackDeleteClick}>Delete Bid Pack Group</button>
                        <FileUploaderModalForm 
                            title="Upload Bid Packs"
                            multiUpload={true}
                            fileGroup={ImportDocumentType.bid_pack}
                            fileGroupId={currentFileGroup().bidPeriodFileGroupId}
                            buttonTextChoose="Browse Documents"
                            buttonTextUpload="Upload Bid Packs"
                            buttonTextMain="Add Bid Packs To Group"
                            newGroupOnUpload={false}
                            onUploadSuccess={onUploadReportUploadSuccess} />
                        <span>Total Bid Pack Files: {currentFileGroup().bidPeriodFiles.length}</span>
                    </div>
                }
                {anyOpenFileGroup() &&
                    <React.Fragment>
                        <div className="bidpackimport-bidpackfiles-tablewrapper">
                            <CclDataTable
                                name={"bidpackFilesTable"}
                                tableData={currentFileGroup().bidPeriodFiles || []}
                                columnDefinitions={bpFileColumnDefs}
                                onRowSelect={null}
                                rowSelect={false}
                                onButtonClick={null} />
                        </div>
                    </React.Fragment>}
            </div>
        </React.Fragment >
    )
}

